module.exports = __webpack_public_path__ + "img/arrow-drop.eb5e1888.svg";